var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 988321"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1400",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "#149752"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 111",
    cx: 8.00001,
    cy: 7.99998,
    r: 4.66667,
    fill: "#149752"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegIcon);
export default __webpack_public_path__ + "static/media/veg-icon.7bafea656c4c49e3d8cdaf0c2f9aaa25.svg";
export { ForwardRef as ReactComponent };